import SocketIO from 'socket.io-client/dist/socket.io.min';

let io;

export const connectSocket = () => {
  if (io?.connected) return io;

  io = SocketIO.connect(process.env.VUE_APP_WEBSOCKET, { transports: ['websocket'] });

  return io;
};
